import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { COMPANY_INFO } from '../companyInfo'
import { LegalFooter } from '../components/LegalFooter'
import styles from './ContactPage.module.css'

// Publiczna strona "Dane kontaktowe" — wymagana przez Przelewy24 w procesie
// weryfikacji sklepu (pełna nazwa firmy, NIP, adres, telefon, e-mail).
// Dostępna bez logowania pod /kontakt, linkowana ze stopki oraz z ekranu
// logowania (motyw Keycloak).
export function ContactPage() {
  const navigate = useNavigate()
  const handleBack = () => {
    if (window.history.length > 1) navigate(-1)
    else navigate('/')
  }

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}>Dane kontaktowe</h1>
        <button type="button" onClick={handleBack} className={styles.backButton}>
          Powrót
        </button>
      </div>

      <main className={styles.main}>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Usługodawca</h2>
          <p className={styles.lead}>
            Właścicielem i operatorem serwisu EasyTacho jest:
          </p>
          <dl className={styles.list}>
            <Row label="Pełna nazwa" value={COMPANY_INFO.legalName} />
            <Row
              label="Adres siedziby"
              value={`${COMPANY_INFO.street}, ${COMPANY_INFO.postalCode} ${COMPANY_INFO.city}, ${COMPANY_INFO.country}`}
            />
            <Row label="NIP" value={COMPANY_INFO.nip} />
            <Row label="REGON" value={COMPANY_INFO.regon} />
            <Row label="KRS" value={`${COMPANY_INFO.krs} (${COMPANY_INFO.krsCourt})`} />
            <Row label="Kapitał zakładowy" value={COMPANY_INFO.shareCapital} />
          </dl>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Kontakt</h2>
          <dl className={styles.list}>
            <Row
              label="Telefon"
              value={
                <a href={`tel:${COMPANY_INFO.phoneHref}`} className={styles.link}>
                  {COMPANY_INFO.phone}
                </a>
              }
            />
            <Row
              label="E-mail (sprawy ogólne, reklamacje)"
              value={
                <a href={`mailto:${COMPANY_INFO.email}`} className={styles.link}>
                  {COMPANY_INFO.email}
                </a>
              }
            />
            <Row
              label="E-mail (wsparcie techniczne)"
              value={
                <a href={`mailto:${COMPANY_INFO.supportEmail}`} className={styles.link}>
                  {COMPANY_INFO.supportEmail}
                </a>
              }
            />
            <Row label="Godziny wsparcia" value={COMPANY_INFO.supportHours} />
            <Row
              label="Adres korespondencyjny"
              value={`${COMPANY_INFO.shortName}, ${COMPANY_INFO.street}, ${COMPANY_INFO.postalCode} ${COMPANY_INFO.city}`}
            />
          </dl>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Reklamacje i odstąpienie od umowy</h2>
          <p className={styles.paragraph}>
            Reklamacje przyjmujemy na adres{' '}
            <a href={`mailto:${COMPANY_INFO.email}`} className={styles.link}>
              {COMPANY_INFO.email}
            </a>
            . Rozpatrujemy je w terminie do 30 dni od dnia zgłoszenia. Zasady
            składania reklamacji, prawo odstąpienia od umowy oraz termin
            aktywacji dostępu po opłaceniu zamówienia opisuje{' '}
            <a href="/terms" className={styles.link}>
              Regulamin
            </a>
            .
          </p>
        </section>
      </main>

      <LegalFooter />
    </div>
  )
}

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className={styles.row}>
      <dt className={styles.term}>{label}</dt>
      <dd className={styles.value}>{value}</dd>
    </div>
  )
}

export default ContactPage
